import * as React from 'react';
const EngineConfigContext = /*#__PURE__*/ React.createContext(null);
export function useEngineConfig() {
    return React.useContext(EngineConfigContext);
}
export const EngineConfigProvider = ({ config, children })=>{
    const parentConfig = useEngineConfig();
    const mergedConfig = React.useMemo(()=>({
            ...parentConfig !== null && parentConfig !== void 0 ? parentConfig : {},
            ...config
        }), [
        parentConfig,
        config
    ]);
    return /*#__PURE__*/ React.createElement(EngineConfigContext.Provider, {
        value: mergedConfig
    }, children);
};

//# sourceMappingURL=EngineConfigProvider.js.map